import { observer } from "mobx-react-lite";
import {
  ItemListSkeletonRowData,
  ItemListAsyncCollectionRowData,
  ItemListRowType,
} from "@/components/item-list/types";
import { FC } from "react";
import { useAppStore } from "@/store";
import { ItemListSkeletonRow } from "./item-list-skeleton-row";
import { ItemListItemRow } from "./item-list-item-row";

export interface ItemListAsyncCollectionRowProps {
  data: ItemListAsyncCollectionRowData;
  className?: string;
}

export const ItemListAsyncCollectionRow: FC<ItemListAsyncCollectionRowProps> = observer(
  ({ data }) => {
    const { store } = useAppStore();
    const collection = store.collections.get(data.payload.collectionId);

    const skeletonRowData: ItemListSkeletonRowData = {
      key: data.key,
      type: ItemListRowType.Skeleton,
      payload: {},
    };
    if (!collection) return <ItemListSkeletonRow data={skeletonRowData} />;

    const itemRowData =
      typeof data.payload.itemRow === "function"
        ? data.payload.itemRow(collection)
        : data.payload.itemRow;
    return <ItemListItemRow data={itemRowData} />;
  }
);
